import React from 'react';
import './Chapters.scss';
import i from '../../Assets/i.jpg';

function Chapter1() {
  return (
    <>
      <section className="chapter">
        {/* <div className="chapter__headerBar" />
        <p className="chapter__title">The Invasion</p> */}

        <p className="chapter__paragraph">
          <span className="chapter__paragraph--dropcap">
            <img src={i} alt="dropcap" />
          </span>
          n March, a video was circulated on social media that depicted the Ukrainian president
          calling on soldiers and citizens to surrender amid the Russian invasion. But the video
          wasn’t real. It was a deepfake, or synthetic media created using sophisticated algorithms
          to appear authentic, often for the purpose of viewer manipulation. Deepfakes can make it
          seem as if a particular person is doing or saying something that never actually happened.
        </p>
        <p className="chapter__paragraph">
          As deepfake videos become more prevalent and technologically more advanced, how can they
          be stopped? And how can we tell if what we’re watching is real?
        </p>
        <p className="chapter__paragraph">
          The U.S. Department of Homeland Security recently released a report titled “Increasing
          Threat of Deepfake Identities,” which looked at “a number of scenarios specific to the
          arenas of commerce, society, and national security.” The report concluded that “The
          likelihood of any one of these scenarios occurring increases as the cost and other
          resources needed to produce usable deepfakes simultaneously decreases.” And Sensity, an
          identity verification company, found that in 2019 the number of deepfake videos doubled
          over a period of seven months—a number that could certainly be higher today.
        </p>
        <p className="chapter__paragraph">
          As the technology and risks of deepfakes evolve, so too do the methods to thwart them,
          including cutting-edge technology developed by Intel’s research division,{' '}
          <a
            href="https://www.intel.com/content/www/us/en/research/overview.html"
            target="_blank"
            rel="sponsored"
            className="link"
          >
            Intel Labs
          </a>
          . An industry-leading research hub with a globally diverse team, Intel Labs identifies
          some of the most challenging issues in technology and works on breakthrough solutions. One
          such team, led by Intel Labs Senior Staff Research Scientist{' '}
          <a href="https://ilkedemir.weebly.com/" target="_blank" rel="sponsored" className="link">
            Dr. Ilke Demir
          </a>{' '}
          has developed the first real-time deepfake detection platform. It uses the biological
          detector called{' '}
          <a
            href="https://ieeexplore.ieee.org/document/9141516"
            target="_blank"
            rel="sponsored"
            className="link"
          >
            FakeCatcher*{' '}
          </a>
          as its core, developed by Dr. Demir and Research Assistant Professor Dr. Umur Aybars
          Ciftci. The innovative real-time platform takes only milliseconds to determine whether a
          video is real or fake by analyzing the video’s pixels to detect the blood flow in the
          subject’s face at certain moments—thus determining whether the subject was filmed in
          real-time or faked.{' '}
          <a
            href="https://www.intel.com/content/www/us/en/newsroom/news/intel-introduces-real-time-deepfake-detector.html#gs.iktqci"
            target="_blank"
            rel="sponsored"
            className="link"
          >
            According to Intel{' '}
          </a>
          the FakeCatcher technology has an accuracy rate of 96%.
        </p>
      </section>
    </>
  );
}

export default Chapter1;
